document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".animated-gallery-carousel__glide");

  function initializeAutoPlayCarousel(carousel, wrapper) {
    const playButton = wrapper.querySelector(".animated-gallery__play");
    const pauseButton = wrapper.querySelector(".animated-gallery__pause");
    const slides = carousel.querySelector(".animated-gallery-carousel__slides");
  
    if (!slides || !playButton || !pauseButton) return;
  
    const originalSlides = slides.children;
    Array.from(originalSlides).forEach((slide) => {
      const clone = slide.cloneNode(true);
      slides.appendChild(clone);
    });
  
    wrapper.classList.add("playing");
    wrapper.classList.remove("paused");
    slides.classList.add("auto-play");
    slides.classList.remove("paused");
  
    playButton.addEventListener("click", () => {
      wrapper.classList.add("playing");
      wrapper.classList.remove("paused");
      slides.classList.add("auto-play");
      slides.classList.remove("paused");
    });
  
    pauseButton.addEventListener("click", () => {
      wrapper.classList.remove("playing");
      wrapper.classList.add("paused");
      slides.classList.add("paused");
    });
  }

  function initializeManualNavigation(carousel, wrapper) {
    const prevButton = wrapper.querySelector(".animated-gallery__prev");
    const nextButton = wrapper.querySelector(".animated-gallery__next");
    const slidesContainer = carousel.querySelector(".animated-gallery-carousel__slides");

    if (!slidesContainer || !prevButton || !nextButton) return;

    // Store original slides
    const originalSlides = Array.from(slidesContainer.children);
    const slideCount = originalSlides.length;

    if (slideCount === 0) return;

    // Clear and rebuild slides
    slidesContainer.innerHTML = '';

    // Add 1 set of clones at start
    originalSlides.forEach(slide => {
      slidesContainer.appendChild(slide.cloneNode(true));
    });

    // Add original slides
    originalSlides.forEach(slide => {
      slidesContainer.appendChild(slide.cloneNode(true));
    });

    // Add 3 sets of clones after
    for (let i = 0; i < 3; i++) {
      originalSlides.forEach(slide => {
        slidesContainer.appendChild(slide.cloneNode(true));
      });
    }

    let currentIndex = slideCount; // Start at first set of original slides
    let isAnimating = false;
    let isResetting = false;

    function calculateSlidePositions() {
      const positions = [0];
      const slides = Array.from(slidesContainer.children);
      const gap = parseInt(window.getComputedStyle(slidesContainer).gap) || 0;
      
      let currentPosition = 0;
      for (let i = 1; i < slides.length; i++) {
        const previousSlide = slides[i - 1];
        currentPosition += previousSlide.offsetWidth + gap;
        positions.push(currentPosition);
      }
      return positions;
    }

    function updateTransform(instant = false) {
      const positions = calculateSlidePositions();
      const offset = -positions[currentIndex];

      if (instant) {
        slidesContainer.style.transition = 'none';
      } else {
        slidesContainer.style.transition = 'transform 0.5s cubic-bezier(0.4, 0.0, 0.2, 1)';
        isAnimating = true;
      }

      requestAnimationFrame(() => {
        slidesContainer.style.transform = `translateX(${offset}px)`;
        
        if (instant) {
          slidesContainer.offsetHeight;
          slidesContainer.style.transition = 'transform 0.5s cubic-bezier(0.4, 0.0, 0.2, 1)';
        }
      });
    }

    function moveSlide(direction) {
      if (isAnimating) return;

      // Calculate next position
      let nextIndex = currentIndex + direction;
      const totalSlides = slideCount * 5; // Total number of slides including all clones

      // Going backwards past the first clone set
      if (nextIndex < slideCount) {
        isResetting = true;
        currentIndex = nextIndex;
        updateTransform();
      } 
      // Going forwards past the third clone set
      else if (nextIndex >= slideCount * 4) {
        isResetting = true;
        currentIndex = nextIndex;
        updateTransform();
      }
      // Normal movement
      else {
        currentIndex = nextIndex;
        updateTransform();
      }
    }

    function handleTransitionEnd() {
      if (isResetting) {
        isResetting = false;
        isAnimating = false;

        // If we went past the end
        if (currentIndex >= slideCount * 4) {
          currentIndex = slideCount + (currentIndex % slideCount);
          updateTransform(true);
        }
        // If we went past the start
        else if (currentIndex < slideCount) {
          currentIndex = (slideCount * 3) + currentIndex;
          updateTransform(true);
        }
      } else {
        isAnimating = false;
      }
    }

    // Event Listeners
    slidesContainer.addEventListener('transitionend', handleTransitionEnd);
    prevButton.addEventListener("click", () => moveSlide(-1));
    nextButton.addEventListener("click", () => moveSlide(1));

    // Initialize carousel
    requestAnimationFrame(() => {
      updateTransform(true);
    });

    // Handle window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateTransform(true);
      }, 100);
    });

    // Handle visibility changes
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        updateTransform(true);
      }
    });
  }

  carousels.forEach((carousel) => {
    const wrapper = carousel.closest(".animated-gallery-carousel");
    if (!wrapper) return;

    const isAutoPlay = wrapper.querySelector(".animated-gallery-carousel__play-pause") !== null;

    if (isAutoPlay) {
      initializeAutoPlayCarousel(carousel, wrapper);
    } else {
      initializeManualNavigation(carousel, wrapper);
    }
  });
});